module.exports = __webpack_public_path__ + "static/media/Hero_Image.ca4bff9a.jpg";